/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listRepos.defs.js'
export * as $defs from './listRepos.defs.js'
